let logoutCallback = null;

export const setLogoutCallback = (fn) => {
  logoutCallback = fn;
};

export const runLogoutCallback = async () => {
  if (logoutCallback) {
    await logoutCallback();
  }
};
